<template>
	<vx-card>
		<CardTicketIntercom
			v-if="['admin', 'manager'].indexOf($store.state.auth.role) !== -1"
			ref="CardTicketIntercom"
			:model="model"
			@updateModel="$emit('updateModel')"
		/>
		<vs-tabs
			:key="model.status"
			:value="indexTab"
			@setActiveTab="setActiveTab"
			@setButtonAction="setButtonAction"
		>
			<vs-tab :label="$t('informationAboutOrder')">
				<table class="order__details">
					<tbody>
						<tr
							v-if=" model.parent_id &&
									['admin', 'manager'].indexOf(
										$store.state.auth.role
									) !== -1
								"
						>
							<td>
								<b>{{ $t("mainOrder") }}</b>
							</td>
							<td>
								<router-link :to="'/ticket/' + model.parent_id" target="_blank">
									{{ model.parent_id }}
								</router-link>
							</td>
						</tr>
						<tr
							v-if="
								['admin', 'manager'].indexOf(
									$store.state.auth.role
								) !== -1
							"
						>
							<td>
								<b>{{ $t("site") }}</b>
							</td>
							<td>
								{{ websiteName }}
							</td>
						</tr>
						<tr
							v-if="
								['admin', 'manager'].indexOf(
									$store.state.auth.role
								) !== -1
							"
						>
							<td>
								<b>{{ $t("date") }}</b>
							</td>
							<td>
								{{ model.created }}
							</td>
						</tr>
						<tr
							v-if="
								['admin', 'manager'].indexOf(
									$store.state.auth.role
								) !== -1
							"
						>
							<td>
								<b>{{ $t("client") }}</b>
							</td>
							<td>
								<RouterLink
									:to="`/${pathToClient}/${clientId}`"
								>
									{{ clientName }}
								</RouterLink>
							</td>
						</tr>
						<tr
							v-if="['admin', 'manager'].includes($store.state.auth.role)
							&& model.message_follow_up
							&& ['offer_sent', 'waiting_payment', 'processing', 'client_not_answer', 'work_long_term'].includes(model.status)"
						>
							<td>
								<b>{{ $t('followUP') }}</b>
							</td>
							<td>
								<vs-alert
									v-if="model.message_follow_up"
									color="primary"
									class="sm:w-1/3"
								>
									{{ followUpLabel }}
								</vs-alert>
							</td>
						</tr>
						<tr
							v-if="
								['admin', 'manager'].indexOf(
									$store.state.auth.role
								) !== -1 && clientPackage
							"
						>
							<td>
								<b>{{ $t("workTypeName") }}</b>
							</td>
							<td class="w-fit">
								<vs-alert color="warning" class="sm:w-1/2">{{ clientPackage }}</vs-alert>
							</td>
						</tr>
						<tr
							v-if="
								['admin', 'manager'].indexOf(
									$store.state.auth.role
								) !== -1
							"
						>
							<td>
									<b>{{ $t("contactTime") }}</b>
							</td>
							<td>
								<vs-alert v-if="model.contact_time" color="warning" class="sm:w-1/3">
									{{ model.contact_time }}
								</vs-alert>
							</td>
						</tr>

						<tr v-if="['admin', 'manager'].indexOf($store.state.auth.role) !== -1 && model.contact_time">
							<td>
								<b>{{ $t('contactTimeReminders') }}</b>
							</td>
							<td>
								<vs-checkbox
									v-model="model.contact_reminder"
									@input="updateTicket"
								></vs-checkbox>
							</td>
						</tr>
						<tr v-if="['admin', 'manager'].indexOf($store.state.auth.role) !== -1">
							<td>
								<b>{{ $t('skipReminders') }}</b>
							</td>
							<td>
								<vs-checkbox
									v-model="model.skip_reminders"
									@input="updateTicket"
								></vs-checkbox>
							</td>
						</tr>
						<tr v-if="['admin', 'manager'].indexOf($store.state.auth.role) !== -1 && model.additional_attributes">
							<td>
								<b>{{ $t('contactViaWhatsapp') }}</b>
							</td>
							<td>
								<vs-checkbox
									v-model="model.additional_attributes.contact_via_whatsapp"
									@input="updateTicket"
								></vs-checkbox>
							</td>
						</tr>
						<tr v-if="['admin', 'manager'].indexOf($store.state.auth.role) !== -1">
							<td>
								<b>{{ $t('doNotDeleteOrderAfterEmails') }}</b>
							</td>
							<td>
								<vs-checkbox
									v-model="model.keep_after_emails"
									@input="updateTicket"
								></vs-checkbox>
							</td>
						</tr>
						<tr
							v-if="
								['admin', 'manager'].indexOf(
									$store.state.auth.role
								) !== -1 && model.additional_attributes && model.additional_attributes.phone
							"
						>
							<td>
								<b>{{ $t("contactPhone") }}</b>
							</td>
							<td>
								{{ model.additional_attributes.phone }}
							</td>
						</tr>
						<tr>
							<td>
								<b>{{ $t("phone") }}</b>
							</td>
							<td>
								{{ model.client ? model.client.phone : "---" }}
							</td>
						</tr>
						<tr>
							<td>
								<b>{{ $t("workTheme") }}</b>
							</td>
							<td>{{ model.name }}</td>
						</tr>
						<tr>
							<td>
								<b>{{ $t("workLanguage") }}</b>
							</td>
							<td>
								{{ $getDeep(model.language, languages) }}
							</td>
						</tr>
						<tr>
							<td>
								<b>{{ $t("subjectArea") }}</b>
							</td>
							<td>
								{{ $getDeep(model.subject, subjects) }}
							</td>
						</tr>
						<tr
							v-if="
								['admin', 'manager'].indexOf(
									$store.state.auth.role
								) !== -1
							"
						>
							<td>
								<b>{{ $t("qualityLevel") }}</b>
							</td>
							<td>{{ $getDeep(model.quality_level, levels) }}</td>
						</tr>
						<tr v-if="['admin', 'manager'].indexOf($store.state.auth.role) !== -1">
							<td>
								<b>{{ $t("promocode") }}</b>
							</td>
							<td>{{ model.promocode }}</td>
						</tr>
						<tr>
							<td>
								<b>{{ $t("dueDate") }}</b>
							</td>
							<td>{{ model.due_date }}</td>
						</tr>
						<tr v-if="['admin', 'manager'].indexOf($store.state.auth.role) !== -1">
							<td><b>{{ $t('authorDeadline') }}</b></td>
							<td>{{ model.author_deadline }}</td>
						</tr>
						<tr>
							<td>
								<b>{{ $t("comment") }}</b>
							</td>
							<td class="break-all hyphens-auto">
								<div
									class="description__container"
									v-html="model.description"
								/>
							</td>
						</tr>
						<template v-for="(work, index) in stagesList">
							<tr :key="index + 'border'" class="top-border">
								<td class="top-border__container" colspan="2">
									<div class="top-border__line"></div>
								</td>
							</tr>
							<tr :key="index + 'type'">
								<td>
									<b>{{ $t("workType") }}</b>
								</td>
								<td>
									{{ $getDeep(work.work_type_id, works) }}
								</td>
							</tr>
							<tr :key="index + 'pages'">
								<td>
									<b>{{ $t("pagesAmount") }}</b>
								</td>
								<td>
									{{ work.pages_number }}
								</td>
							</tr>
							<tr :key="index + 'due_date'">
								<td>
									<b>{{ $t("dueDate") }}</b>
								</td>
								<td>
									<!-- {{ getDate(work.due_date) }} -->
									{{ work.due_date }}
									<span class="tooltip" v-if="$store.state.auth.role === 'author' && !work.is_paid">
										<feather-icon
											svgClasses="h-4 w-4 text-primary"
											icon="InfoIcon"
										></feather-icon>
									<span class="tooltiptext">{{ $t("deadlineCalculatedApproximately") }}</span>
								</span>
								</td>
							</tr>
							<tr
								v-if="$store.state.auth.role === 'author'"
								:key="index + 'status'"
							>
								<td>
									<b>{{ $t("status") }}</b>
								</td>
								<td
									class="rounded p-2"
									:class="[`bg-${setWorkStatusClass(work)}`]"
									style="color: white"
								>
									{{ setWorkStatus(work) }}
								</td>
							</tr>
						</template>
						<tr :key="index + 'border'" class="top-border">
							<td class="top-border__container" colspan="2">
								<div class="top-border__line"></div>
							</td>
						</tr>
						<tr
							v-if="
								['admin', 'manager'].indexOf(
									$store.state.auth.role
								) !== -1
							"
						>
							<td>
								<b>{{ $t("paymentMethod") }}</b>
							</td>
							<td>
								{{ getPayType }}
							</td>
						</tr>
						<tr class="top-border" v-if="
								['admin', 'manager'].indexOf(
									$store.state.auth.role
								) !== -1 && model.additional_attributes && model.additional_attributes.order_details
							"
						>
							<td class="top-border__container" colspan="2">
								<div class="top-border__line"></div>
							</td>
						</tr>
						<tr
							v-if="
								['admin', 'manager'].indexOf(
									$store.state.auth.role
								) !== -1 && model.additional_attributes && model.additional_attributes.order_details && model.is_ppg !== 1
							"
						>
							<td>
								<b>{{ $t("details") }}</b>
							</td>
							<td>
								{{ model.additional_attributes.order_details }}
							</td>
						</tr>
						<tr class="top-border"
							v-if="
								['admin', 'manager'].indexOf(
									$store.state.auth.role
								) !== -1 && model.additional_attributes && (model.additional_attributes.client_file || model.additional_attributes.client_files)
							">
							<td class="top-border__container" colspan="2">
								<div class="top-border__line"></div>
							</td>
						</tr>
						<tr
							v-if="
								['admin', 'manager'].indexOf(
									$store.state.auth.role
								) !== -1 && model.additional_attributes && (model.additional_attributes.client_file || model.additional_attributes.client_files)
							"
						>
							<td>
								<b>{{ $t("client_file") }}</b>
							</td>
							<td v-if="model.additional_attributes.client_file">
								<a target="_blank" :href="model.additional_attributes.client_file.file">
									{{ model.additional_attributes.client_file.file }}
								</a>
							</td>
							<td v-if="model.additional_attributes.client_files">
								<div
									v-for="(client_file, index) in model.additional_attributes.client_files"
									:key="index"
									class="mb-2"
								>
									<a target="_blank" :href="client_file.file" class="display-block">
										{{ client_file.file }}
									</a>
									<button
										v-if="showButton"
										:disabled="client_file.isSended === 1"
										@click="sendFile(client_file)"
										class="add__btn"
									>
										+
									</button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<CardTicketUtm
					v-if="
						['admin', 'manager'].indexOf($store.state.auth.role) !==
							-1 &&
							(model.utm || model.source  || (model.additional_attributes && model.additional_attributes.vwo_splits))
					"
					:utm="model.utm"
					:source="model.source"
					:additional-attributes="model.additional_attributes"
				/>
			</vs-tab>
			<vs-tab
				v-if="canShowCommentsTab"
				:label="commentsTabLabel"
				class="px-0">
				<VuePerfectScrollbar :settings="settings" class="pr-4">
					<div v-if="commentsList" class="messages-list">
						<ul v-for="(item, index) in commentsList" :key="index">
							<li class="d-flex column list-item pb-1 mb-4">
								<p>{{ item.content }}</p>
								<div class="d-flex mt-2 justify-between">
									<p>
										{{
											item.author.firstName +
												" " +
												item.author.lastName
										}}
									</p>
									<p>{{ item.created }}</p>
								</div>
							</li>
						</ul>
					</div>
				</VuePerfectScrollbar>

				<VuePerfectScrollbar :settings="settings" class="pr-4 mt-6" v-if="model.failed_comment">
					<div class="my-4">
						{{ $t('failComment') }}
					</div>
					<div v-if="commentsList" class="messages-list">
						<ul>
							<li class="d-flex column list-item pb-1 mb-4">
								<p>{{ model.failed_comment }}</p>
								<div class="d-flex mt-2 justify-between">
									<p>{{ model.failed_by.first_name + " " + model.failed_by.last_name}}</p>

									<p>{{ model.fail_created_at }}</p>
								</div>
							</li>
						</ul>
					</div>
				</VuePerfectScrollbar>
				<VuePerfectScrollbar :settings="settings" class="pr-4 mt-6" v-if="model.closure_status">
					<div class="my-4">
						{{ $t('closureComment') }}
					</div>
					<div v-if="commentsList" class="messages-list">
						<ul>
							<li class="d-flex column list-item pb-1 mb-4">
								<p>{{ model.closure_status.status_label }}.</p>
								<p>{{ model.closure_status.comment }}</p>
								<div class="d-flex mt-2 justify-between">
									<p>{{ model.closure_status.closed_by.first_name + " " + model.closure_status.closed_by.last_name}}</p>

									<p>{{ model.closure_status.created_at }}</p>
								</div>
							</li>
						</ul>
					</div>
				</VuePerfectScrollbar>
				<div class="mt-3">
					<vs-textarea
						v-model="commentText"
						:label="$t('comment')"
						rows="4"
					/>
				</div>
				<div class="set-ticket-failed__controls">
					<vs-button
						class="mr-1"
						color="primary"
						:disabled="!commentText || disableCommentButton"
						@click="sendComment"
						>{{ $t("send") }}</vs-button
					>
				</div>
			</vs-tab>

			<vs-tab :label="$t('history')"
					class="px-0">
				<OrderHistory
					:orderId="model.id"
				>
				</OrderHistory>
			</vs-tab>
			<vs-tab
				v-if="canShowCommentsTab"
				:label="$t('edit')"
				class="px-0"
				isButton
			></vs-tab>

			<vs-tab
				v-if="showQualityButton"
				:label="$t('quality')"
				class="px-0"
			>
				<div
					v-if="!qualityMessages.length && isLoading"
					class="p-3 align-center"
				>
					{{ $t("loading") }}...
				</div>

				<VuePerfectScrollbar
					ref="verticalNavMenuPs"
					:settings="settings"
					class="pr-4"
				>
					<div v-if="qualityMessages.length" class="messages-list">
						<ul
							v-for="(item, index) in qualityMessages"
							:key="index"
						>
							<li class="d-flex column list-item pb-1 mb-4">
								<p>{{ item.message }}</p>

								<div class="d-flex mt-2 justify-between">
									<p class="font-bold list-item__name">
										{{
											item.user
												? item.user.userName
												: "..."
										}}
									</p>

									<p>{{ item.createdAt }}</p>
								</div>
							</li>
						</ul>
					</div>

					<div ref="endOfQualityMessages"></div>
				</VuePerfectScrollbar>

				<div class="mt-3">
					<vs-textarea
						v-model="qualityMessageText"
						:label="$t('problemsWithQuality')"
						rows="4"
					/>
				</div>

				<div class="set-ticket-failed__controls">
					<vs-button
						class="mr-1"
						color="primary"
						:disabled="!qualityMessageText || isLoading"
						@click="sendQualityMessage"
					>
						{{ $t("send") }}
					</vs-button>
				</div>
			</vs-tab>

			<vs-tab v-if="model.suborders && model.suborders.length" :label="$t('createSuborder')" class="px-0">
				<VuePerfectScrollbar ref="verticalNavMenuPs" :settings="settings" class="pr-4">
					<div class="p-3">
						<table class="w-full text-left border-collapse">
							<thead>
							<tr>
								<th class="pb-2 border-b">{{ $t('createSuborder') }}</th>
								<th class="pb-2 border-b">{{ $t('creationDate') }}</th>
								<th class="pb-2 border-b">{{ $t('createdBy') }}</th>
							</tr>
							</thead>
							<tbody>
							<tr v-for="(sub, index) in model.suborders" :key="index">
								<td class="py-2">
									<a :href="sub.link" target="_blank" class="text-blue-500 hover:underline">
										{{ sub.id }}
									</a>
								</td>
								<td>{{ sub.created }}</td>
								<td>{{ sub.created_by || '—' }}</td>
							</tr>
							</tbody>
						</table>
					</div>
				</VuePerfectScrollbar>
			</vs-tab>

		</vs-tabs>
	</vx-card>
</template>

<script>
import databaseManager from "../../mixins/databaseManager";
import notifier from "@/mixins/notifier";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import CardTicketUtm from "@/views/Tickets/CardTicketUtm.vue";
import CardTicketIntercom from "@/views/Tickets/CardTicketIntercom.vue";
import moment from "moment/moment";
import OrderHistory from "@/components/order/OrderHistory.vue";

export default {
	name: "CardTicketView",
	components: {
		OrderHistory,
		VuePerfectScrollbar,
		CardTicketUtm,
		CardTicketIntercom,
	},
	props: {
		model: { default: () => ({}) },
		levels: { default: () => [] },
		subjects: { default: () => [] },
		works: { default: () => [] },
		languages: { default: () => [] },
		payTypes: { default: () => [] },
		stages: { default: () => [] },
		isEditView: { default: false },
	},
	mixins: [databaseManager, notifier],

	data() {
		return {
			updateTimeout: null,
			commentText: "",
			indexTab: 0,
			disableCommentButton: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 1,
				swipeEasing: true
			},
			qualityMessages: [],
			qualityMessageText: "",
			isLoading: false
		};
	},

	computed: {
		authRole() {
			return this.$store.state.auth.role;
		},
		showButton() {
			if (this.authRole === "admin" || this.authRole === "manager")
				return true;
			return false;
		},
		getPayType() {
			if (this.payTypes.length && !!this.model) {
				const payType = this.payTypes.find(
					el => el.status === this.model.pay_type
				);
				return payType ? payType.label : "---";
			}
			return "---";
		},
		canShowCommentsTab() {
			const role = this.$store.state.auth.role;
			return role === "manager" || role === "admin";
		},
		commentsTabLabel() {
			const commentsTitle = this.$t("comments");

			if (this.model) {
				let count = 0;

				if (Array.isArray(this.model.comments)) {
					count += this.model.comments.length;
				}

				if (this.model.failed_comment) {
					count += 1;
				}
				if (this.model.closure_status) {
					count += 1;
				}

				if (count > 0) {
					return `${commentsTitle} (${count})`;
				}
			}

			return commentsTitle;
		},
		followUpStatuses() {
			return [
				{ name: this.$t('statusRequest1'), value: 'status_request_1' },
				{ name: this.$t('statusRequest2'), value: 'status_request_2' },
				{ name: this.$t('statusRequest3'), value: 'status_request_3' },
				{ name: this.$t('statusRequest4'), value: 'status_request_4' },
				{ name: this.$t('statusRequest5'), value: 'status_request_5' },
				{ name: this.$t('waitingForPayment1'), value: 'waiting_for_payment_1' },
				{ name: this.$t('waitingForPayment2'), value: 'waiting_for_payment_2' },
				{ name: this.$t('waitingForPayment3'), value: 'waiting_for_payment_3' },
				{ name: this.$t('offerFollowUp'), value: 'offer' },
				{ name: this.$t('deleteFollowUp'), value: 'delete' },
			];
		},
		followUpLabel() {
			const item = this.followUpStatuses.find(
				i => i.value === this.model.message_follow_up
			);
			return item ? item.name : '';
		},
		commentsList() {
			return this.model.comments ? this.model.comments : null;
		},
		clientId() {
			if (!this.model.client) return "---";
			return this.model.client.id;
		},
		clientName() {
			if (!this.model.client) return "---";
			return this.model.client.full_name !== ""
				? this.model.client.full_name
				: "---";
		},
		clientPackage() {
			if (!this.model.client) return "---";
			return this.model.client.package;
		},
		pathToClient() {
			const role = this.$store.state.auth.role;
			if (role === "admin") {
				return "client";
			} else if (role === "manager") {
				return "clientM";
			}
		},
		websiteName() {
			return this.model.website || "---";
		},
		stagesList() {
			return this.stages && this.stages.length
				? this.stages
				: this.model.work_types;
		},
		showQualityButton() {
			return (
				this.model.id &&
				this.model.status !== "new" &&
				this.model.status !== "client_not_answer" &&
				this.model.status !== "processing" &&
				this.model.status !== "waiting_payment" &&
				this.model.status !== "waiting_author"
			);
		}
	},

	watch: {
		async indexTab(newVal) {
			if (newVal) {
				this.commentText = "";
				this.clearQualityData();
			}

			if (newVal === 3) {
				await this.getQualityMessages();
			}
		}
	},

	methods: {
		async sendFile(file) {
			try {
				const response = await this.$http.post(
					`${this.$store.state.auth.role}/order/add-file-by-base-path`,
					{
						order_id: this.model.id,
						file_base_path: file.base_patch
					}
				);
				this.notifySuccess(this.$t('addedSuccessfully'));
				this.$emit('updateModel')

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		clearQualityData() {
			this.qualityMessageText = "";
			this.qualityMessages = [];
		},

		setWorkStatusClass(work) {
			if (work.status === "completed" || work.is_paid) return "success";
			else return "danger";
		},

		setWorkStatus(work) {
			if (!work) return "";
			if (work.status === "completed") return this.$t("completed");
			else if (work.is_paid) return this.$t("workIsPaidCanContinue");
			else return this.$t("workIsNotPaidWait");
		},

		setButtonAction() {
			this.$emit("update:isEditView", true);
		},

		setActiveTab(data) {
			this.indexTab = data;
		},

		async sendComment() {
			this.disableCommentButton = true;
			try {
				await this.dbSendComment(this.model.id, this.commentText);
				this.disableCommentButton = false;
				this.notifySuccess(this.$t("addedSuccessfully"));
				this.commentText = "";
				this.$emit("updateModel");
			} catch (e) {
				this.notifyError(e.message);
				this.disableCommentButton = false;
			}
		},

		getDate(date) {
			return date
				? date
						.split("-")
						.reverse()
						.join(".")
				: "";
		},

		openImagePopup(e, file) {
			this.$emit("openImagePopup", e, file);
		},

		async sendQualityMessage() {
			if (!this.model) {
				return;
			}
			try {
				this.isLoading = true;
				const res = await this.dbSetQualityProblemMessage({
					message: this.qualityMessageText,
					id: this.model.id
				});
				this.qualityMessageText = "";
				this.qualityMessages = res.items.reverse();

				this.scrollBottomQualityMessages();
			} catch (err) {
				console.error(err);
			} finally {
				this.isLoading = false;
			}
		},

		async getQualityMessages() {
			if (!this.model) {
				return;
			}
			try {
				this.isLoading = true;
				const res = await this.dbGetQualityProblemsMessages({
					id: this.model.id
				});
				this.qualityMessages = res.items.reverse();
				this.scrollBottomQualityMessages();
			} catch (err) {
				console.error(err);
			} finally {
				this.isLoading = false;
			}
		},

		scrollBottomQualityMessages() {
			this.$nextTick(() => {
				this.$refs.verticalNavMenuPs.$el.scrollTop = 1000000;
			});
		},
		async updateTicket(recalcPrices = false) {
			await this.updateTicketAsync();
			setTimeout(() => {
				this.$emit('recalcPrices', recalcPrices)
			}, 1000);
		},
		async updateTicketAsync(isImmediate = false){
			if(await this.$validator.validateAll() !== true) return;

			if(!isImmediate) {
				if(this.updateTimeout !== null) {
					clearTimeout(this.updateTimeout);
				}

				this.updateTimeout = setTimeout(() => {
					this.updateTicketAsync(true);
					this.updateTimeout = null;
				}, 700);

				return;
			}

			try {
				if(await this.$validator.validateAll() !== true) return;

				const date = this.model.due_date ? moment(this.model.due_date).format("YYYY-MM-DD") : null

				const workTypes = this.model.work_types;

				const data = {
					name: this.model.name,
					subject: this.model.subject,
					work_types: workTypes.map(item => ({
						work_type: item.work_type_id,
						pages_number: item.pages_number,
					})),
					quality_level: this.model.quality_level,
					pages_number: this.model.pages_number,
					language: this.model.language,
					pay_type: this.model.pay_type,
					due_date: date,
					description: this.model.description,
					skip_reminders: this.model.skip_reminders ? 1 : 0,
					contact_reminder: this.model.contact_reminder ? 1 : 0,
					contact_via_whatsapp: this.model.additional_attributes && this.model.additional_attributes.contact_via_whatsapp ? 1 : 0,
					contact_time: this.model.contact_time,
					keep_after_emails: this.model.keep_after_emails ? 1 : 0,
					generator_manager_id: this.model.generator_manager_id,
					message_follow_up: this.model.message_follow_up,
					additional_sale: this.model.additional_sale,
				};

				const updated = await this.dbUpdateOrder(this.model.id, data);
			}catch (e) {
				this.notifyError(e.message);
			}
		},
	}
};
</script>

<style lang="scss">
.description__container {
	& > * {
		max-width: 100%;
	}
	pre {
		text-wrap: unset;
	}
	s {
		text-decoration: line-through;
	}
	table {
		width: 100%;

		td {
			padding: 0 !important;
			word-break: break-word;
		}
	}
	ul, ol {
		padding-left: 20px !important;
	}
	ol {
		list-style-type: revert;
	}
	ul {
		list-style: unset;
	}
}

.ps {
	max-height: 450px;
}

.messages-list {
	overflow-y: auto;
	scrollbar-width: thin;

	.list-item {
		border-bottom: 1px solid #cfcfcf;

		&__name {
			font-size: 0.9rem;
			align-self: flex-end;
			line-height: 1;
		}
	}
}

.order__details {
	width: 100%;
	border-spacing: 0;

	td {
		vertical-align: top;
		word-break: break-word;

	}

	tr > td:first-child {
		max-width: 45%;
		width: 45%;
		padding-right: 15px;
	}

	.top-border {
		column-span: 2;

		&__container {
			padding-top: 10px;
			padding-bottom: 15px;
		}

		&__line {
			border-top: 1px solid #e4e4e4;
		}
	}

	.add__btn {
			height: 30px;
			padding: 0 10px;
			margin-left: 0.5rem;
			border: none;
			border-radius: 40%;
			background: #3ac47d;
			cursor: pointer;
			transition: all ease 0.3s;
			color: white;

			&:hover {
				background: #258352;
			}

			&:disabled {
				background: #3ac47d6c;
				cursor: default;
			}
	}
	@media screen and (max-width: 500px) {
		tr > td:first-child {
			max-width: 50%;
			width: 50%;
		}
	}
	tr:hover td {
		background-color: #faf7f7;
	}
}
/* Tooltip container */
.tooltip {
	position: relative;
	display: inline-block;
	.tooltiptext {
		visibility: hidden;
		width: 280px;
		background-color: black;
		color: #fff;
		text-align: center;
		padding: 8px 4px;
		border-radius: 6px;
		font-size: 12px;

		/* Position the tooltip text - see examples below! */
		position: absolute;
		z-index: 1;
	}
	&:hover .tooltiptext {
		visibility: visible;
	}
}
.display-block {
	display: block;
}
</style>
